/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CertificateEdgeItem } from './CertificateEdgeItem';
import {
    CertificateEdgeItemFromJSON,
    CertificateEdgeItemFromJSONTyped,
    CertificateEdgeItemToJSON,
} from './CertificateEdgeItem';

/**
 * Related delegated signer credential
 * @export
 * @interface EdgedCredentialDetailedDto
 */
export interface EdgedCredentialDetailedDto {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof EdgedCredentialDetailedDto
     */
    said?: string;
    /**
     * 
     * @type {string}
     * @memberof EdgedCredentialDetailedDto
     */
    type?: EdgedCredentialDetailedDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EdgedCredentialDetailedDto
     */
    status?: EdgedCredentialDetailedDtoStatusEnum;
    /**
     * Human-readable Identifier for Credential. Set by creator of the credential
     * @type {string}
     * @memberof EdgedCredentialDetailedDto
     */
    credentialAlias?: string;
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof EdgedCredentialDetailedDto
     */
    issueeAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof EdgedCredentialDetailedDto
     */
    issueeAlias?: string;
    /**
     * AID of issuer - who created that credential
     * @type {string}
     * @memberof EdgedCredentialDetailedDto
     */
    issuerAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof EdgedCredentialDetailedDto
     */
    issuerAlias?: string;
    /**
     * When the credential was issued in format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof EdgedCredentialDetailedDto
     */
    issuedAt?: string;
    /**
     * When the credential was revoked if it was revoked. Format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof EdgedCredentialDetailedDto
     */
    revokedAt?: string;
    /**
     * Schema ID of the credential
     * @type {string}
     * @memberof EdgedCredentialDetailedDto
     */
    schemaId?: string;
    /**
     * 
     * @type {{ [key: string]: CertificateEdgeItem; }}
     * @memberof EdgedCredentialDetailedDto
     */
    certificateChainMap?: { [key: string]: CertificateEdgeItem; };
}


/**
 * @export
 */
export const EdgedCredentialDetailedDtoTypeEnum = {
    Unknown: 'UNKNOWN',
    Dossier: 'DOSSIER',
    OrgIdentity: 'ORG_IDENTITY',
    Range: 'RANGE',
    Brand: 'BRAND',
    TnAlloc: 'TN_ALLOC',
    DelSig: 'DEL_SIG',
    Qvi: 'QVI',
    Root: 'ROOT',
    A2PCampaign: 'A2P_CAMPAIGN'
} as const;
export type EdgedCredentialDetailedDtoTypeEnum = typeof EdgedCredentialDetailedDtoTypeEnum[keyof typeof EdgedCredentialDetailedDtoTypeEnum];

/**
 * @export
 */
export const EdgedCredentialDetailedDtoStatusEnum = {
    Active: 'ACTIVE',
    Expired: 'EXPIRED',
    Revoked: 'REVOKED'
} as const;
export type EdgedCredentialDetailedDtoStatusEnum = typeof EdgedCredentialDetailedDtoStatusEnum[keyof typeof EdgedCredentialDetailedDtoStatusEnum];


/**
 * Check if a given object implements the EdgedCredentialDetailedDto interface.
 */
export function instanceOfEdgedCredentialDetailedDto(value: object): boolean {
    return true;
}

export function EdgedCredentialDetailedDtoFromJSON(json: any): EdgedCredentialDetailedDto {
    return EdgedCredentialDetailedDtoFromJSONTyped(json, false);
}

export function EdgedCredentialDetailedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EdgedCredentialDetailedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'] == null ? undefined : json['said'],
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
        'credentialAlias': json['credentialAlias'] == null ? undefined : json['credentialAlias'],
        'issueeAid': json['issueeAid'] == null ? undefined : json['issueeAid'],
        'issueeAlias': json['issueeAlias'] == null ? undefined : json['issueeAlias'],
        'issuerAid': json['issuerAid'] == null ? undefined : json['issuerAid'],
        'issuerAlias': json['issuerAlias'] == null ? undefined : json['issuerAlias'],
        'issuedAt': json['issuedAt'] == null ? undefined : json['issuedAt'],
        'revokedAt': json['revokedAt'] == null ? undefined : json['revokedAt'],
        'schemaId': json['schemaId'] == null ? undefined : json['schemaId'],
        'certificateChainMap': json['certificateChainMap'] == null ? undefined : (mapValues(json['certificateChainMap'], CertificateEdgeItemFromJSON)),
    };
}

export function EdgedCredentialDetailedDtoToJSON(value?: EdgedCredentialDetailedDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'type': value['type'],
        'status': value['status'],
        'credentialAlias': value['credentialAlias'],
        'issueeAid': value['issueeAid'],
        'issueeAlias': value['issueeAlias'],
        'issuerAid': value['issuerAid'],
        'issuerAlias': value['issuerAlias'],
        'issuedAt': value['issuedAt'],
        'revokedAt': value['revokedAt'],
        'schemaId': value['schemaId'],
        'certificateChainMap': value['certificateChainMap'] == null ? undefined : (mapValues(value['certificateChainMap'], CertificateEdgeItemToJSON)),
    };
}

